import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import {
  CTA_UNLOCK_YOUR_OFFER,
  DISCLAIMER_CONSULTATION_RESULTS_CANCEL,
} from 'consts/copy';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_BRANDED_RESPONSE_CONTENT: SimpleHeroProps = {
  header: (
    <React.Fragment>
      Full-service <br css={mobileOnly()} />
      skincare <br />
      starts here
    </React.Fragment>
  ),
  body: 'Forget generic products without real results—get paired with a licensed dermatology provider, who will prescribe you a personalized formula to help you reach your skin goals.',
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_OFFER,
    disclaimerText: (
      <React.Fragment>{DISCLAIMER_CONSULTATION_RESULTS_CANCEL}</React.Fragment>
    ),
  },
  media: (
    <React.Fragment>
      <StaticImage
        src="../images/headerBrandResponseDesktop@2x.jpg"
        alt="woman holding Curology bottle"
        width={640}
        css={desktopOnly()}
        loading="eager"
      />
      <StaticImage
        src="../images/headerBrandResponseMobile@2x.jpg"
        alt="woman holding Curology bottle"
        loading="eager"
        layout="fullWidth"
        css={mobileOnly()}
        width={767}
      />
    </React.Fragment>
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
};
